import { type CustomField } from '@webapp/core/entities/internal/CustomField'
import { CreatePOCustomFieldForm } from '@webapp/modules/purchasing/features/create-po-custom-field/views/CreatePOCustomFieldForm'
import { useCreatePOCustomFieldFormPresenter } from './useCreatePOCustomFieldFormPresenter'

export interface ICreatePOCustomFieldFormPresenterProps {
  existingFields: CustomField[]
  totalCount: number
  onSuccess: () => void
  onCancel: () => void
}

export const CreatePOCustomFieldFormPresenter = ({
  existingFields,
  totalCount,
  onSuccess,
  onCancel,
}: ICreatePOCustomFieldFormPresenterProps) => {
  const {
    states: { isSaving },
    handlers: { handleSubmit },
  } = useCreatePOCustomFieldFormPresenter({
    existingFields,
    totalCount,
    onSuccess,
  })

  return (
    <CreatePOCustomFieldForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSaving={isSaving}
    />
  )
}

CreatePOCustomFieldFormPresenter.displayName =
  'CreatePOCustomFieldFormPresenter'
